<template>
  <div>
    <loading :active.sync="isLoading" color="#85344c"></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <router-link to="/adm/assinantes">Assinantes</router-link>
          </li>
          <li class="breadcrumb-item active">Detalhe assinante {{nomeUsuario}}</li>
        </ol>

        <div class="row">
          <div class="col-md-12" v-if="mostraErro">
            <div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
              <strong>Ops!</strong>
              <span>{{erroMensagem}}</span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <button
              v-if="naoIntegrou"
              class="btn_1 medium pull-right mb-3 mx-4"
              @click="() => integraOdontosfera()"
            >
              Integrar Sistema
            </button>
            <button
              class="btn_1 medium pull-right mb-3 mx-4"
              @click="enviarDados()"
              
            >
              <i class="fa fa-paper-plane"></i> Copiar Dados
            </button>
            <button
              class="btn_1 medium pull-right mb-3"
              @click="() => { $bvModal.show('modalCarteirinha')}"
              v-if="subscription.status !== 'canceled'"
            >
              Carteirinha
            </button>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-file"></i>Dados do contratante
            </h2>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label>Usuário</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Informe seu nome"
                  v-model="nomeUsuario"
                >
              </div>
            </div>
              <div class="col-4">
              <div class="form-group" v-if="subscriber.user">
                <label>E-mail</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Telefone"
                  v-model="subscriber.user.email"
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Telefone</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Telefone"
                  v-model="telefone"
                >
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label>CEP</label>
                <input
                  v-mask="'#####-###'"
                  type="text"
                  class="form-control"
                  v-model="subscriber.zip_code"
                >
              </div>
            </div>
            <div class="col-md-9">
              <div class="form-group">
                <label>Cidade</label>
                <input
                  type="text"
                  class="form-control"
                  readonly
                  v-model="subscriber.city"
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2">
              <div class="form-group">
                <label>Estado</label>
                <input
                  type="text"
                  class="form-control"
                  readonly
                  v-model="subscriber.state"
                >
              </div>
            </div>
            <div class="col-md-10">
              <div class="form-group">
                <label>Bairro</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscriber.district"
                >
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-6">
              <div class="form-group">
                <label>Logradouro</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscriber.street"
                >
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Número</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscriber.street_number"
                >
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label>Complemento</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscriber.complement"
                >
              </div>
            </div>
            <div class="col-md-3" v-if="subscriber">
              <router-link target="_blank" :to="`/adm/usuarios/${(subscriber.user) ? subscriber.user.id : '' }`">Detalhes do usuário</router-link>
            </div>
          </div>
        </div>

         <div class="box_general padding_bottom" v-if="vendaNoCartao">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-credit-card"></i>Informações do Cartão de Crédito
            </h2>
          </div>
          <div class="row" v-if="!verDadosDoCartao">
            <div class="col-12">
              <p>Visando a segurança dos dados dos clientes da plataforma, as informações do cartão de crédito estão <b>criptografados</b>. Ao solicitar a visualização, você estará ciente de que esta ação será realizada por seu acesso, sendo de sua responsabilidade a manipulação dos dados criptografados.</p>
              
            <button
              class="btn_1 medium pull-right mb-3"
              @click="verCartao()"
            >
              Ver dados do cartão
            </button>
            </div>
          </div>
          <div class="row" v-else>
            <div class="col-4">
              <div class="form-group">
                <label>Número do Cartão</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Número do cartão"
                  v-model="card.number"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Nome Impresso</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Nome"
                  v-model="card.holder_name"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>CPF do titular do cartão de crédito</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="-/-"
                  v-model="card.cpf"
                  readonly
                >
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Mês Expiração</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Mês de expiração"
                  v-model="card.expiration_month"
                  readonly
                >
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Ano Expiração</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Ano de expiração"
                  v-model="card.expiration_year"
                  readonly
                >
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Código de Segurança</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="CVV"
                  v-model="card.cvv"
                  readonly
                >
              </div>
            </div>
            <div class="col-3">
              <div class="form-group">
                <label>Bandeira</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="card.bandeira"
                  readonly
                >
              </div>
            </div>
            </div>
          </div>
         
         <div class="box_general padding_bottom" v-else>
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-money"></i>Venda no Boleto
            </h2>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group horizontal flex-center justify-between">
                <label>Link do boleto</label>
                <input
                  type="text"
                  class="form-control objetos-70"
                  placeholder="Número do cartão"
                  v-model="subscription.boleto"
                  readonly
                >
              <button
                class="btn_1"
                @click="(event) => copiaConteudo(event.target, subscription.boleto)"
                >
                Copiar
                <i class="fa fa-fw fa-copy"></i>
              </button>
              </div>
            </div>
          </div>
         </div>


         <div class="box_general padding_bottom" v-if="titular">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-file"></i>Informações do Titular
            </h2>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label>Nome</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Número do cartão"
                  v-model="titular.name"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>CPF</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Número do cartão"
                  v-model="titular.cpf"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>RG</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Número do cartão"
                  v-model="titular.rg"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Nome da mãe</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Número do cartão"
                  v-model="titular.nome_mae"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Data de nascimento</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Número do cartão"
                  v-model="titular.birth_date"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>E-mail</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="E-mail"
                  v-model="titular.email"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Estado Civil</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Estado Civil"
                  v-model="titular.estado_civil"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Gênero</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Gênero"
                  v-model="titular.genero"
                  readonly
                >
              </div>
            </div>
          </div>
         </div>


        <div class="row">
          <div class="col-md-12">
            <button
              class="btn_1 medium pull-right mb-3"
              @click="solicitaConfirmacao()"
              v-if="subscription.status !== 'canceled'"
              >
              Notificar Participantes
              </button>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-users"></i>Participantes
            </h2>
          </div>
          <div class="row">
            <p>Confira abaixo os dados dos participantes do plano</p>
            <div class="col-9 text-right">
              <button class="btn_1" @click="abreModalCriaDependente()">
                  Criar Participante
              </button>
            </div>
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Nome</th>
                    <th>Aniversário</th>
                    <th>RG</th>
                    <th>CPF</th>
                    <th>Mãe</th>
                    <th>Plano</th>
                    <th>Parentesco</th>
                    <th>Estado Civil</th>
                    <th>Gênero</th>
                    <th>CNS</th>
                    <th>Carteirinha</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="dependente.id" v-for="dependente of dependentes">
                    <td>{{dependente.name}}</td>
                    <td>{{padronizaData(dependente.birth_date)}}</td>
                    <td>{{dependente.rg}}</td>
                    <td>{{dependente.cpf}}</td>
                    <td>{{dependente.nome_mae}}</td>
                    <td>{{dependente.nome_plano}}</td>
                    <td>{{dependente.parentesco}}</td>
                    <td>{{dependente.estado_civil}}</td>
                    <td>{{dependente.genero}}</td>
                    <td>{{(dependente.cns) ? dependente.cns : '-/-'}}</td>
                    <td>{{(dependente.carteirinha) ? dependente.carteirinha : 'Não cadastrado'}}</td>
                    <td>
                      <button
                        class="btn_1"
                        @click="abreModalDetalhesDependente(dependente)"
                        >
                        <i class="fa fa-fw fa-pencil"></i>
                      </button>
                    </td>
                    <td v-if="mostraDelete(dependentes.length)">
                      <button
                        class="btn_1"
                        @click="abreModalDeletaDependente(dependente)"
                        style="background-color: red; color: white;"
                        >
                        <i class="fa fa-fw fa-trash"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="box_general padding_bottom">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-file"></i>Informações da Assinatura
            </h2>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label>Plano</label>
                <input 
                  v-model="subscription.plans_description"
                  readonly
                  type="text"
                  class="form-control"/>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Valor</label>
                <money 
                  v-model="subscription.custom_price"
                  readonly
                  v-bind="money" 
                  type="text"
                  class="form-control">
                </money>
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Status</label>
                <select
                  class="form-control"
                  v-model="subscription.status"
                >
                  <option disabled value="">Selecione um status</option>
                  <option value="active">Ativo</option>
                  <option value="canceled">Cancelado</option>
                  <option value="error">Erro</option>
                  <option value="suspended">Suspensão</option>
                </select>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label>Protocolo</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscription.protocolo"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Data cobrança</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="subscription.data_pagamento"
                  readonly
                >
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Nome do Corretor</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="nomeCorretor"
                  readonly
                >
              </div>
            </div>
            <button class="btn_1 mt-2 pull-right mr-3" @click="salvaInfoAssinatura()">
                  Salvar
            </button>
            <button
                class="btn_1 medium mt-2 mr-3 pull-left delete"
                @click="cancelarAssinatura()"
              >
                Cancelar assinatura
              </button>
              <!-- <button
                  class="btn_1 medium mt-2 mr-3 pull-left success"
                @click="restaurarAssinatura()"
                :disabled="verificarSePassouUmaSemana(subscription.updated_at) || subscription.status === 'Erro'"
              >
                Reativar assinatura
              </button> -->
          </div>
        </div>

        <div v-for="(rec, index) in lista_recorrencias" :key="rec.id" class="box_general padding_bottom mb-4 border p-3">
          <div class="header_box version_2">
            <h2><i class="fa fa-refresh"></i> Recorrência #{{ index + 1 }}</h2>
            <!-- <small>ID Cielo: {{ rec.recurrent_payment_id }}</small> -->
          </div>

          <div class="row">
            <div class="col-4">
              <div class="form-group">
                <label>Data de Início</label>
                <input class="form-control" :value="rec.StartDateFormatted" readonly />
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Próxima Cobrança</label>
                <input class="form-control" :value="rec.NextRecurrencyFormatted" readonly />
              </div>
            </div>

            <div class="col-4">
              <div class="form-group">
                <label>Dia do Mês</label>
                <input class="form-control" :value="rec.RecurrencyDay" readonly />
              </div>
            </div>

            <div class="col-4">
              <div class="form-group">
                <label>Valor</label>
                <input class="form-control" :value="'R$ ' + rec.formatted_amount" readonly />
              </div>
            </div>

            <div class="col-4">
              <div class="form-group">
                <label>Pagamento Atual</label>
                <input class="form-control" :value="rec.SuccessfulRecurrences" readonly />
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Tentativa Atual</label>
                <input class="form-control" :value="rec.CurrentRecurrencyTry" readonly />
              </div>
            </div>
            <div class="col-4">
              <div class="form-group">
                <label>Status</label>
                <input class="form-control" :value="rec.StatusExtenso" readonly />
              </div>
            </div>
            <div class="col-8">
              <div class="form-group">
                <label>Recurrent Payment Id</label>
                <input class="form-control" 
                v-model="rec.RecurrentPaymentId"
                type="text"
                readonly />
              </div>
            </div> 

          </div>

            <div class="row">
        
            </div>
<!--           <div class="mt-3" v-if="rec.transactions && rec.transactions.length > 0">
            <h6>Histórico de Transações</h6>
            <table class="table table-sm table-striped">
              <thead>
                <tr>
                  <th>Data</th>
                  <th>Valor</th>
                  <th>Status (Cielo)</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="t in rec.transactions" :key="t.id">
                  <td>{{ padronizaData(t.created_at) }}</td>
                  <td>R$ {{ t.formatted_t_amount }}</td>
                  <td>{{ t.status_description }}</td>
                </tr>
              </tbody>
            </table>
          </div> -->
           <div class="row mr-3">
              <button
                v-if="subscription.status != ('active')"
                class="btn_1 medium mt-2 mr-3 pull-left success"
                @click="restaurarAssinatura()"
                :disabled="verificarSePassouUmaSemana(subscription.updated_at) || subscription.status === 'Erro'"
              >
                Reativar assinatura
              </button>
            </div>
        </div>

        <div class="box_general padding_bottom" v-show="vendaNoCartao">
          <div class="header_box version_2">
            <h2>
              <i class="fa fa-repeat"></i>Histórico de Cobranças
            </h2>
          </div>
          <div class="row">
            <div class="table-responsive">
              <table class="table table-striped">
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Valor</th>
                    <th>Status</th>
                    <th
                    >
                      Ações
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr :key="recorrencia.id" v-for="recorrencia of recorrencias">
                    <td >{{padronizaDataCompleta(subtract_hours(recorrencia.created_at, 3))}}</td>
                    <td>R$ {{numberWithCommas(recorrencia.amount)}}</td>
                    <td>{{recorrencia.status_description}} <i class="fa fa-question" v-if="recorrencia.payment_id" @click="visualizarPaymentId(recorrencia.payment_id)"></i></td>
                   <td >
                    <button v-if="(verificarSePassouUmDia(recorrencia.created_at) || verificarSePassouUmaSemana(recorrencia.created_at)) && recorrencia.status_code == 2" class="btn_1 btn_cancelar" @click=" cancelarPagamento(recorrencia)">
                      {{
                        verificarSePassouUmDia(recorrencia.created_at)
                          ? "Cancelar Pagamento"
                          : verificarSePassouUmaSemana(recorrencia.created_at)
                          ? "Estornar Pagamento"
                          : ""
                      }}
                    </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div
            class="row"
          >
            <div class="col-md-12">
              <template v-if="subscription.recurrent_payment_uuid">
                <button class="btn_1  mt-2 pull-right" @click="$bvModal.show('modalInfoCartao')"
                v-if="subscription.status !== 'Cancelado' && subscription.status !== 'Erro'"
                >
                  Trocar Cartão
                </button>
                <button
                  class="btn_1  mt-2 mr-3 pull-right"
                  @click="openModalValorRecorrencia()"
                  v-if="subscription.status !== 'Cancelado' && subscription.status !== 'Erro'"
                >
                  Valor da Cobrança
                </button>
                <button
                  class="btn_1  mt-2 mr-3 pull-right"
                  @click="openModalDiaRecorrencia()"
                  v-if="subscription.status !== 'Cancelado' && subscription.status !== 'Erro'"
                >
                  Mudar Data da Próxima Cobrança
                </button>
                <button
                  class="btn_1  mt-2 mr-3 pull-right"
                  @click="openModalAlterarDiaRecorrencia()"
                  v-if="subscription.status !== 'Cancelado' && subscription.status !== 'Erro'"
                >
                  Alterar dia da Recorrência
                </button>
                <button
                  class="btn_1  mt-2 mr-3 pull-right"
                  @click="openModalCobrancaUnica()"
                  v-if="subscription.status !== 'Cancelado' && subscription.status !== 'Erro'"
                >
                  Cobrança Única
                </button>
              </template>
              <button
                v-if="subscription.status != 'Cancelado' && subscription.status !== 'Erro'"
                class="btn_1 medium mt-2 mr-3 pull-left delete"
                @click="cancelarAssinatura()"
              >
                Cancelar assinatura
              </button>
              <button
                v-else
                class="btn_1 medium mt-2 mr-3 pull-left success"
                @click="restaurarAssinatura()"
                :disabled="verificarSePassouUmaSemana(subscription.updated_at) || subscription.status === 'Erro'"
              >
                Reativar assinatura
              </button>
            </div>
          </div>
        </div>
      </div>
      <!-- /container-fluid-->
    </div>

    <!-- Modal Component -->
    <b-modal
      id="modalInfoCartao"
      title="Informações Cartão"
      centered
      ok-title="Salvar"
      ok-only
      @ok="trocaInfoCartao"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Nº Cartão</label>
            <input
              v-model="card_temp.number"
              placeholder="Numero Cartao"
              inputmode="numeric"
              v-mask="'#### #### #### ####'" 
              class="form-control"
            />
          </div>
        </div>
        <hr />
        <div class="col-12">
          <div class="form-group">
            <label>Nome Impresso no Cartão</label>
            <input
              v-model="card_temp.holder_name"
              placeholder="Insira o nome impresso no cartão"
              type="text"
              class="form-control"
            />
          </div>
        </div>
        <hr />
        <div class="col-6">
          <div class="form-group">
            <label>Data de Expiração</label>
            <input
              v-model="card_temp.expiration"
              placeholder="00/00"
              v-mask="['##/##']"
              inputmode="numeric"
              class="form-control"
            />
          </div>
        </div>
        <div class="col-6">
         <div class="form-group">
            <label>CVV</label>
            <input
              v-model="card_temp.cvv"
              placeholder="000"
              inputmode="numeric"
              v-mask="'###'" 
              class="form-control"
            />
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalCarteirinha"
      title="Carteirinha"
      centered
      ok-title="Fechar"
      ok-only
      @ok="salvaCarteirinha()"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Informe a carteirinha</label>
            <input 
              v-model="carteirinha"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-12">
          <b-form-group label="Enviar e-mail de notificação?">
            <b-form-radio v-model="enviar_email" name="notifica-radios" value="0">NÃO</b-form-radio>
            <b-form-radio v-model="enviar_email" name="notifica-radios" value="1">SIM</b-form-radio>
          </b-form-group>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalDeleta"
      title="Atenção"
      centered
      ok-title="Sim"
      ok-only
      @ok="DeletaDependente()"
      ok-variant="btn_1 full-width"
    >
    <div class="col-12">
      <p>Deseja apagar esse dependente?</p>
    </div>
    </b-modal>

    <b-modal
      id="modalDependente"
      title="Carteirinha"
      centered
      ok-title="Salvar"
      ok-only
      @ok="editaDependente()"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Informe a carteirinha</label>
            <input 
              v-model="dependenteEditado.carteirinha"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <hr>
        <div class="col-6">
          <div class="form-group">
            <label>Nome</label>
            <input 
              v-model="dependenteEditado.name"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Aniversário</label>
            <date-picker 
              v-model="dependenteEditado.birth_date"
              format="DD/MM/YYYY"
              :lang="lang"
              value-type="format"></date-picker>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>RG</label>
            <input 
              v-model="dependenteEditado.rg"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>CPF</label>
            <input 
              v-model="dependenteEditado.cpf"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Nome da Mãe</label>
            <input 
              v-model="dependenteEditado.nome_mae"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Plano</label>
            <select v-model="dependenteEditado.nome_plano" class="form-control">
              <option v-for="plano in planos" :value="plano.name">{{ plano.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Parentesco</label>
            <select v-model="dependenteEditado.parentesco" class="form-control">
              <option value="Nenhum, sou responsável financeiro">Nenhum, sou responsável financeiro</option>
              <option value="Cônjuge">Cônjuge</option>
              <option value="Convivente, sem eventual concorrência com o cônjuge, salvo por decisão judicial">Convivente, sem eventual concorrência com o cônjuge, salvo por decisão judicial</option>
              <option value="Filhos solteiro, até 21 anos incompletos, ou até 24 anos incompletos, desde que cursando graduação em nível superior de ensino">Filhos solteiro, até 21 anos incompletos, ou até 24 anos incompletos, desde que cursando graduação em nível superior de ensino</option>
              <option value="Enteado, o menor sob a guarda por força de decisão judicial e o menor tutelado, que ficam equiparados aos filhos">Enteado, o menor sob a guarda por força de decisão judicial e o menor tutelado, que ficam equiparados aos filhos</option>
              <option value="Neto(a)/bisneto(a)">Neto(a)/bisneto(a)</option>
              <option value="Irmão(ã)">Irmão(ã)</option>
              <option value="Pais">Pais, avós e bisavós</option>
              <option value="Tio(a)">Tio(a)</option>
              <option value="Sogro(a)">Sogro(a)</option>
              <option value="Genro/nora">Genro/nora</option>
              <option value="Cunhado(a)">Cunhado(a)</option>
              <option value="Padrasto/madrasta">Padrasto/madrasta</option>
              <option value="Sobrinho(a)">Sobrinho(a)</option>
            </select>
            </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>CNS</label>
            <input 
              v-model="dependenteEditado.cns"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Estado Civil</label>
            <select v-model="dependenteEditado.estado_civil" class="form-control">
              <option value="Solteiro">Solteiro</option>
              <option value="Sasado">Casado</option>
              <option value="Divorciado">Divorciado</option>
              <option value="Viuvo">Viúvo</option>
              <option value="Separado">Separado</option>
              <option value="Desquitado">Desquitado</option>
              <option value="Convivente">Convivente</option>
              <option value="Arnasiado">Arnasiado</option>
              <option value="Divorciado">Divorciado</option>
              <option value="Outros">Outros</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Gênero</label>
            <select v-model="dependenteEditado.genero" class="form-control">
              <option value="Masculino">Masculino</option>
              <option value="Feminino">Feminino</option>
              <option value="Outros">Outros</option>
            </select>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalCriaDependente"
      title="Carteirinha"
      centered
      ok-title="Salvar"
      ok-only
      @ok="CriaDependente()"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <!-- <div class="col-12">
          <div class="form-group">
            <label>Informe a carteirinha</label>
            <input 
              v-model="novoDependente.dependents[0].carteirinha"
              type="text"
              class="form-control"/>
          </div>
        </div> -->
        <hr>
        <div class="col-6">
          <div class="form-group">
            <label>Nome</label>
            <input 
              v-model="novoDependente.dependents[0].name"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Aniversário</label>
            <date-picker 
              v-model="novoDependente.dependents[0].birth_date"
              format="DD/MM/YYYY"
              :lang="lang"
              value-type="format"></date-picker>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>RG</label>
            <input 
              v-model="novoDependente.dependents[0].rg"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>CPF</label>
            <input 
              v-model="novoDependente.dependents[0].cpf"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Email</label>
            <input 
              v-model="novoDependente.dependents[0].email"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Nome da Mãe</label>
            <input 
              v-model="novoDependente.dependents[0].nome_mae"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Nome do Pai</label>
            <input 
              v-model="novoDependente.dependents[0].nome_pai"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Plano</label>
            <select v-model="novoDependente.dependents[0].plan_id" class="form-control">
              <option v-for="plano in planos" :value="plano.id">{{ plano.name }}</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Parentesco</label>
            <select v-model="novoDependente.dependents[0].parentesco" class="form-control">
              <option value="Nenhum, sou responsável financeiro">Nenhum, sou responsável financeiro</option>
              <option value="Cõnjuge">Cônjuge</option>
              <option value="Convivente, sem eventual concorrência com o cônjuge, salvo por decisão judicial">Convivente, sem eventual concorrência com o cônjuge, salvo por decisão judicial</option>
              <option value="Filhos solteiro, até 21 anos incompletos, ou até 24 anos incompletos, desde que cursando graduação em nível superior de ensino">Filhos solteiro, até 21 anos incompletos, ou até 24 anos incompletos, desde que cursando graduação em nível superior de ensino</option>
              <option value="Enteado, o menor sob a guarda por força de decisão judicial e o menor tutelado, que ficam equiparados aos filhos">Enteado, o menor sob a guarda por força de decisão judicial e o menor tutelado, que ficam equiparados aos filhos</option>
              <option value="Neto(a)/bisneto(a)">Neto(a)/bisneto(a)</option>
              <option value="Irmão(ã)">Irmão(ã)</option>
              <option value="Pais, avós e bisavós">Pais, avós e bisavós</option>
              <option value="Tio(a)">Tio(a)</option>
              <option value="Sogro(a)">Sogro(a)</option>
              <option value="Genro/nora">Genro/nora</option>
              <option value="Cunhado(a)">Cunhado(a)</option>
              <option value="Padrasto/madrasta">Padrasto/madrasta</option>
              <option value="Sobrinho(a)">Sobrinho(a)</option>
            </select>
            </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>CNS</label>
            <input 
              v-model="novoDependente.dependents[0].cns"
              type="text"
              class="form-control"/>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Estado Civil</label>
            <select v-model="novoDependente.dependents[0].estado_civil" class="form-control">
              <option value="Solteiro">Solteiro</option>
              <option value="Sasado">Casado</option>
              <option value="Divorciado">Divorciado</option>
              <option value="Viuvo">Viúvo</option>
              <option value="Separado">Separado</option>
              <option value="Desquitado">Desquitado</option>
              <option value="Convivente">Convivente</option>
              <option value="Arnasiado">Arnasiado</option>
              <option value="Divorciado">Divorciado</option>
              <option value="Outros">Outros</option>
            </select>
          </div>
        </div>
        <div class="col-6">
          <div class="form-group">
            <label>Gênero</label>
            <select v-model="novoDependente.dependents[0].genero" class="form-control">
              <option value="Masculino">Masculino</option>
              <option value="Feminino">Feminino</option>
              <option value="Outros">Outros</option>
            </select>
          </div>
        </div>
      </div>
    </b-modal>
    
     <b-modal
      id="modalValorRecorrencia"
      title="Editar Valor da Recorrência"
      centered
      ok-title="Salvar"
      ok-only
      @ok="editaRecorrencia"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Valor Atual</label>
            <money
              v-model="subscription.custom_price"
              readonly
              v-bind="money"
              type="text"
              class="form-control"
            >
            </money>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Novo Valor</label>
            <input 
              class="form-control" 
              v-model="temp_recorrencia.amount"
              inputmode="numeric"
              v-mask="['R$ #,##', 'R$ ##,##', 'R$ ###,##', 'R$ ####,##', 'R$ #####,##', 'R$ ######,##', 'R$ #######,##']" 
            />
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalDiaRecorrencia"
      title="Editar Próxima cobrança da Recorrência"
      centered
      ok-title="Salvar"
      ok-only
      @ok="editaRecorrencia"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Dia Atual</label>
            <input class="form-control" 
            v-model="dataAtual"
            type="text"
            readonly />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Novo Dia</label>
            <date-picker
                  v-model="temp_recorrencia.next_recurrency"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                ></date-picker>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalAlterarDiaRecorrencia"
      title="Editar Dia da Recorrência"
      centered
      ok-title="Salvar"
      ok-only
      @ok="editaRecorrencia"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Dia Atual de Recorrência</label>
            <input class="form-control" 
            v-model="dataAtual"
            type="text"
            readonly />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Novo Dia</label>
            <date-picker
                  v-model="temp_recorrencia.recurrency_day"
                  :lang="lang"
                  format="DD/MM/YYYY"
                  value-type="format"
                ></date-picker>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
      id="modalCobrancaUnica"
      title="Cobrança Única"
      centered
      ok-title="Confirmar"
      ok-only
      @ok="confirmarCobrancaUnica"
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Valor Atual da Cobrança</label>
            <money
              v-model="subscription.custom_price"
              readonly
              v-bind="money"
              type="text"
              class="form-control"
            ></money>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Valor da Cobrança Única</label>
            <input 
              class="form-control" 
              v-model="temp_cobranca_unica.amount"
              inputmode="numeric"
              v-mask="['R$ #,##', 'R$ ##,##', 'R$ ###,##', 'R$ ####,##', 'R$ #####,##', 'R$ ######,##', 'R$ #######,##']" 
            />
          </div>
        </div>
      </div>
    </b-modal>

    <!-- <b-modal
      id="modalConsultaRecorrencia"
      title="Consulta da Recorrência"
      centered
      ok-title="Fechar"
      ok-only
      ok-variant="btn_1 full-width"
    >
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Próxima Recorrência</label>
            <input class="form-control" 
            v-model="NextRecurrency"
            type="text"
            readonly />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Data de Início</label>
            <input class="form-control" 
            v-model="StartDate"
            type="text"
            readonly />
          </div>
        </div>
      </div>
      
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Valor</label>
            <input class="form-control" 
            v-model="consulta_recorrencia.Amount"
            type="text"
            readonly />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Tentativa de Pagamento Atual</label>
            <input class="form-control" 
            v-model="consulta_recorrencia.CurrentRecurrencyTry"
            type="text"
            readonly />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Status</label>
            <input class="form-control" 
            v-model="RecurrencyStatus"
            type="text"
            readonly />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Dia de Recorrência</label>
            <input class="form-control" 
            v-model="consulta_recorrencia.RecurrencyDay"
            type="text"
            readonly />
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Recurrent Payment Id</label>
            <input class="form-control" 
            v-model="subscription.recurrent_payment_uuid"
            type="text"
            readonly />
          </div>
        </div>
      </div>
    </b-modal> -->
  
  </div>

  
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import funcoesGerais from "@/assets/js/funcoes.js";
import { toDate, toTimeStamp } from "@/utils/formater";
import moment from "moment";
import {Money} from 'v-money'

export default {
  components: {
    Money
  },
  mixins: [funcoesGerais],
  data() {
    return {
      temp_cobranca_unica: {
        amount: ''
      },
      lista_recorrencias: [],
      protocolo: this.$route.params.protocolo,
      flagTrue: true,
      flagFalse: false,
      mostraErro: false,
      isLoading: false,
      dependentes: [],
      recorrencias: [],
      subscriber: {},
      dependenteEditado: {},
      titular: null,
      subscription: {},
      telefone: "",
      carteirinha: "",
      status: "",
      nomeCorretor: "",
      nomeUsuario: "",
      dataAtual:"",
      consulta_recorrencia: {},
      temp_recorrencia: {},
      StartDate: '',
      NextRecurrency: '',
      RecurrencyStatus: '',
      RecurrencyStatusDefinitions: [
        '1 - Ativo', 
        '2 - Finalizado', 
        '3 - Desativado pelo Lojista', 
        '4 - Desativado por Número de Retentativas', 
        '5 - Desativada por Cartão de Crédito Vencido'
      ],
      lang: {
		days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
	  months: [
		"Jan",
		"Fev",
		"Mar",
		"Abr",
		"Mai",
		"Jun",
		"Jul",
		"Ago",
		"Set",
		"Out",
		"Nov",
		"Dec"
	  ],
	  pickers: [
		"prox 7 dias",
		"prox 30 dias",
		"7 dias anteriores",
		"30 dias anteriores"
	  ],
		placeholder: {
		  date: "Selecione a data",
		  dateRange: "Selecione o intervalo"
		}
	  },
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2,
        masked: false
      },
      phone: {
        number: '',
        area_code: ''
      },
      card: {
        expiration_month: '',
        expiration_year: '',
        number: '',
        holder_name: '',
        cvv: '',
        bandeira: '',
        expiration: '',
      },
      card_temp: {
        expiration_month: '',
        expiration_year: '',
        number: '',
        holder_name: '',
        cvv: '',
        bandeira: '',
        expiration: '',
      },
      enviar_email: 0,
      vendaNoCartao: true,
      naoIntegrou: true,
      verDadosDoCartao: false,
      dadosDesincriptografados: false,
      planos:[],
      novoDependente: {
        dependents: [{}]
      },
      dependenteDeletado:{},
    };
  },
  created() {
    var self = this;
    var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
    self.isLoading = true;
    if (user) {
      self.isLoading = true;
      ajax("get", "/assinatura/" + self.protocolo + "/adm")
        .then((response) => {
          self.isLoading = false;
            self.subscriber = response.subscriber;
            if(response.subscriber.titular){
              self.titular = response.subscriber.titular;
              self.titular.birth_date = self.padronizaData(self.titular.birth_date);
            }else{
              self.titular = '';
            }
            self.dependentes = response.dependentes;

            if(response.subscription.transactions) {
              self.recorrencias = response.subscription.transactions;
            }
            for(let i = 0; i < self.recorrencias.length; i++){
            for(let j = i+1; j < self.recorrencias.length; j++){
                if(self.recorrencias[i].created_at < self.recorrencias[j].created_at){
                    const temp = self.recorrencias[j];
                    self.recorrencias[j] = self.recorrencias[i];
                    self.recorrencias[i] = temp;
                }   
            }
          }
            
            self.subscription = response.subscription;
            self.carteirinha = response.subscription.carteirinha;
            self.subscription.custom_price = response.subscription.custom_price/100;
            self.subscription.created_at = self.padronizaDataCompleta(self.subtract_hours(response.subscription.created_at, 3));
            self.subscription.data_pagamento = self.padronizaData(self.subscription.data_pagamento);
            self.dataAtual = self.subscription.data_pagamento;
            self.subscription.end_date = self.subscription.end_date ? self.subscription.end_date : 'Não possui';
            if(response.phone){
              self.telefone = response.phone.area_code + ' ' + response.phone.number;
            }
          if (response.card) {
            self.vendaNoCartao = true;
          } else {
            self.vendaNoCartao = false;
          }
            self.nomeUsuario = response.subscriber.user.name + ' ' + response.subscriber.user.last_name;
            
            (response.corretor) ? self.nomeCorretor = response.corretor.name : self.nomeCorretor = "Sem corretor";

            if(self.subscription.recurrent_payment_uuid) this.consultaRecorrencia(); this.consultaRecorrenciaCPF(); 
        
            self.naoIntegrou = (response.integration) ? true : false;
        })
        .catch((error) => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    } else {
      self.$router.replace(self.$route.query.redirect || "/");
    }
  },
  methods: {
    traduzStatus(status) {
      var traducoesStatus = {
        'pending': 'Pendente',
        'active': 'Ativo',
        'suspended': 'Suspenso',
        'expired': 'Expirado',
        'overdue': 'Atrasado',
        'expired': 'Expirado',
        'canceled': 'Cancelado',
        'Pago': 'Pago',
        'error': 'Erro'
      };
      return traducoesStatus[status];
    },
    salvaInfoAssinatura() {
      this.isLoading = true;
      ajax("put", `/assinaturas/${this.subscription.id}`, this.subscription)
        .then((res) => {
          this.isLoading = false;
          alerta(
            "success",
            "Sucesso",
            "Informações da assinatura salvas com sucesso!"
          );
        })
        .catch((error) => {
          this.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    restaurarAssinatura() {
      this.$swal
        .fire({
          title: "Atenção!",
          text: "Deseja realmente realizar essa ação?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Confirmar",
        })
        .then((result) => {
          if (result.value) {
            this.isLoading = true;
        ajax("put", `reativar_recorrencia/${this.subscription.id}`)
          .then((res) => {
            this.isLoading = false;
            this.$router.push({path: '/uniodonto/assinantes/'})
            alerta(
              "success",
              "Sucesso",
              "Assinatura reativada com sucesso!"
            );
          })
          .catch((e) => {
            this.isLoading = false;
            tratamento_requisicao(e);
          });
          }
        });

    },
     cancelarAssinatura() {
      if (document.getElementsByClassName('btn_cancelar').length > 0) {
        alerta("warning", 
            'Atenção!', 
            'Cancele ou Estorne o último pagamento antes de cancelar a assinatura.'
          );
      }
      else if (!this.subscription.recurrent_payment_uuid && this.subscription.plan.recorrencia == 1) {
        alerta("warning", 
            'Não há registro de recorrência para essa assinatura', 
            'Por favor, verifique o recurrent_payment_id no site da Cielo e entre em contato com nossa equipe técnica'
          );
      }
      else if (this.subscription.status === 'canceled') {
        alerta("warning", 
            'Não foi possivel cancelar a assinatura', 
            'Assinatura já está cancelada'
          );
      }
      else {
        let texto;
        if (this.subscription.status === 'Ativo') texto = "Deseja realmente realizar essa ação? Se sim, informe o protocolo no campo abaixo:";
          else texto = "Esta assinatura aparenta ter cobranças em aberto. Deseja realmente realizar essa ação? Se sim, informe o protocolo no campo abaixo:";

        this.$swal
          .fire({
            title: "Atenção!",
            text: texto,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Confirmar",
            input: 'text',
            inputValidator: (value) => {
              if (!value) {
                return 'Informe o protocolo!'
              }
              if(value !== this.subscription.protocolo) return 'Código inválido'
            }
          })
          .then((result) => {
            if (result.value) {
              this.isLoading = true;
          ajax("delete", `deletar_recorrencia/${this.subscription.id}`)
            .then((res) => {
              this.isLoading = false;
              this.$router.push({path: '/adm/assinantes/'})
              alerta(
                "success",
                "Sucesso",
                "Assinatura cancelada com sucesso!"
              );
            })
            .catch((e) => {
              this.isLoading = false;
              tratamento_requisicao(e);
            });
            }
          });
      }
    },
    openModalValorRecorrencia(){
       this.$bvModal.show('modalValorRecorrencia');
    },
    openModalCobrancaUnica(){
       // Limpa o valor anterior
       this.temp_cobranca_unica.amount = '';
       this.$bvModal.show('modalCobrancaUnica');
    },
    openModalDiaRecorrencia() {
      this.$bvModal.show('modalDiaRecorrencia');
    },
    openModalAlterarDiaRecorrencia() {
      this.$bvModal.show('modalAlterarDiaRecorrencia');
    },

    async confirmarCobrancaUnica() {
      try {
        // Verifica se há um valor válido
        if (!this.temp_cobranca_unica.amount) {
          this.$toast.warning('Informe um valor para a cobrança única');
          return;
        }

        // Formata o valor removendo R$ e convertendo para o formato correto
        const valorNumerico = parseFloat(
          this.temp_cobranca_unica.amount
            .replace('R$', '')
            .trim()
            .replace(/\./g, '')
            .replace(',', '.')
        );

        // Verifica se o valor é válido
        if (isNaN(valorNumerico) || valorNumerico <= 0) {
          this.$toast.warning('Informe um valor válido para a cobrança');
          return;
        }
        
        // Atualiza o valor no formulário para exibição no formato R$ 82,90
        this.temp_cobranca_unica.amount = `R$ ${valorNumerico.toFixed(2).replace('.', ',')}`;

        // Mostra loading
        this.isLoading = true;

        // Chama a API para processar a cobrança
        ajax("post", `assinatura/checkout-unica`, {
          subscriptionId: this.subscription.id,
          valor: this.emCentavos(valorNumerico)  // Valor em centavos (ex: 8290)
        })
        .then((res) => {

          this.isLoading = false;
          // Fecha o modal
          this.$bvModal.hide('modalCobrancaUnica');

          alerta("success",
                "Atualizado",
                "Cobrança única processada com sucesso!"
          );
        })
        .catch((e) => {
          tratamento_requisicao(e);
        })
        .finally(() => {
          this.isLoading = false;
        });
        
      } catch (error) {
        console.error('Erro ao processar cobrança única:', error);
        const mensagemErro = (error.response && error.response.data && error.response.data.message) 
          ? error.response.data.message 
          : 'Erro ao processar cobrança. Tente novamente.';
        this.$toast.error(mensagemErro);
      } finally {
        this.isLoading = false;
      }
    },
    editaRecorrencia() {
      let self = this;

      this.$swal.fire({
          title: 'Atenção!',
          text: "Deseja realmente editar esse item?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar'
      }).then((result) => {
        if (result.value) {
          self.isLoading = true;
          if (self.temp_recorrencia.recurrency_day) {
            self.temp_recorrencia.recurrency_day = self.temp_recorrencia.recurrency_day.split("/")[0]+'/'+self.temp_recorrencia.recurrency_day.split("/")[1];
          }
         if (self.temp_recorrencia.amount && typeof self.temp_recorrencia.amount === 'string' && self.temp_recorrencia.amount.includes('R$')) {
              self.temp_recorrencia.amount = Number(self.temp_recorrencia.amount.substring(3).replace(',', ''));
            }
          
          if(self.temp_recorrencia.amount !== "" && self.temp_recorrencia.amount !== 0) {
            ajax(
              "post",
              "/atualizar_recorrencia/" + self.subscription.id,
              self.temp_recorrencia
            )
            .then((response) => {
              self.isLoading = false;
              alerta(
                "success",
                "Atualizado",
                "Recorrência atualizada com sucesso!"
              );
              let index = self.recorrencias.findIndex(
                (item) => item.id == self.temp_recorrencia.id
              );
              self.recorrencias[index] = self.temp_recorrencia;
            })
            .catch((error) => {
              self.isLoading = false;
              tratamento_requisicao(error, this);
            });
          } else {
            self.isLoading = false;
            alerta("warning", "Atenção", 'Novo valor inválido.');
          }
        }
      })
    },
    verificarSePassouUmDia(date) {
      const one_day = 24 * 60 * 60 * 1000;
      return !(
        new Date(Date.now()).getTime() - one_day > new Date(date).getTime()
      );
    },
    verificarSePassouUmaSemana(date) {
      const one_week = 7 * 24 * 60 * 60 * 1000;
      return !(
        new Date(Date.now()).getTime() - one_week > new Date(date).getTime()
      );
    },
    cancelarPagamento({id, payment_id}){
      this.$swal.fire({
        title: 'Atenção!',
        text: "Deseja realmente excluir esse item?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',    
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar'
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          ajax("post", `cancelar_pagamento/${this.subscription.id}`, {payment_id: payment_id})
          .then((res) => {
            this.isLoading = false;
            this.recorrencias[this.recorrencias.findIndex(item => item.id == id)] = res;
            
            alerta(
              "success",
              "Sucesso",
              "Operação realizada com sucesso!"
            );
          })
          .catch((e) => {
            this.isLoading = false;
            tratamento_requisicao(e);
          });
        }
      })
    },
    trocaInfoCartao(){
      const currentYear = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      let expirationValidate = false;
      if(Number(`20${this.card_temp.expiration.split("/")[1]}`) === currentYear) {
        expirationValidate = this.card_temp.expiration.split("/")[0] >= currentMonth && this.card_temp.expiration.split("/")[0] < 13 && this.card_temp.expiration.length === 5 ? true : false;
      } else if(Number(`20${this.card_temp.expiration.split("/")[1]}`) > currentYear) {
        expirationValidate = this.card_temp.expiration.split("/")[0] > 0 && this.card_temp.expiration.split("/")[0] < 13 && this.card_temp.expiration.length === 5 ? true : false;
      }
      const numberValidate = this.card_temp.number.replaceAll(' ', '').length === 16 ? true : false;
      const holderValidate = this.card_temp.holder_name !== '' ? true : false;
      const cvvValidate = this.card_temp.cvv.length === 3 ? true : false;
    
      if (numberValidate && holderValidate && expirationValidate && cvvValidate) {
        this.card_temp.expiration_month = this.card_temp.expiration.split("/")[0];
        this.card_temp.expiration_year = `20${this.card_temp.expiration.split("/")[1]}`

        this.card_temp.id_subscription = this.card.id_subscription;

        let obj = {
          creditcard: {
            brand: this.getCardType(this.card_temp.number),
            holder: this.card_temp.holder_name,
            cardNumber: this.card_temp.number.replaceAll(' ', ''),
            expirationDate: `${this.card_temp.expiration_month}/${this.card_temp.expiration_year}`,
            securityCode: this.card_temp.cvv,
            amount: Number(this.consulta_recorrencia.Amount.toFixed(2).replace('.', ''))
          },
        };
        
        this.$swal.fire({
          title: 'Atenção!',
          text: "Deseja realmente editar esse item?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Confirmar'
        }).then((result) => {
          if (result.value) {
            this.isLoading = true;
            ajax('post', `atualizar_recorrencia/${this.card.id_subscription}`, obj)
            .then(() => {
              this.isLoading = false;
              this.card = this.card_temp
              this.card_temp = {}
              alerta("success", "Sucesso", "Informações do cartão alteradas com sucesso");
            }).catch(e => {
              this.isLoading = false;
              tratamento_requisicao(e)
            })
          }
        })
      } else {
        if(!numberValidate) alerta("warning", "Atenção", 'Número do cartão inválido.')
        else if(!holderValidate) alerta("warning", "Atenção", 'Preencha o nome do titular.')
        else if(!expirationValidate) alerta("warning", "Atenção", 'Data de expiração inválida.')
        else if(!cvvValidate) alerta("warning", "Atenção", 'Código de segurança inválido.')
        this.isLoading = false;
      }
    },
    
    subtract_hours(date, hours){
      let data = new Date(date)
      data.setHours(data.getHours() - hours);
      return data;      
    },
    getCardType(number) {
      let re = new RegExp("^4");
      if (number.match(re) != null) return "visa";

      re = new RegExp("^(34|37)");
      if (number.match(re) != null) return "amex";

      re = new RegExp("^5[1-5]");
      if (number.match(re) != null) return "Master";

      re = new RegExp("^6011");
      if (number.match(re) != null) return "discover";

      return "visa"; // default type
    },
    emCentavos(valor) {
      return Math.round(valor * 100);
    },
    salvaCarteirinha() {
      var self = this;
      self.isLoading = true;
      let param = {
        carteirinha: self.carteirinha,
        enviar_email: self.enviar_email
      }
      ajax("put", "/assinaturas/"+ self.subscription.id, param)
        .then(response => {
          self.isLoading = false;
            alerta(
               "success",
               "Atualizado",
               "Carteirinha atualizada com sucesso!"
             );
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    emReais(valor) {
      return (valor / 100).toFixed(2);
    },
    numberWithCommas(num) {
      var temp = this.emReais(num);
      return temp.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
    },
    padronizaData(data) {
      return data ? moment(String(data)).format("DD/MM/YYYY") : "";
    },
    padronizaDataCompleta(data) {
      return data ? moment(String(data)).format("DD/MM/YYYY H:mm") : "";
    },
    integraOdontosfera(){
      var self = this;
      if(confirm("Tem certeza que deseja enviar o cadastro a odontosfera?")){
        self.isLoading = true;
        ajax("get", '/integrations/send/'+self.subscription.id)
        .then((res) => {
          this.isLoading = false;
          alerta(
            "success",
            "Sucesso",
            "Integração realizada com sucesso!"
          );
          console.log(res);
        })
        .catch((e) => {
          self.isLoading = false;
          console.log(e);
          tratamento_requisicao(e);
        });
      }

    },
    mostraDelete(dependentCount) {
      return dependentCount > 1;
    },
    editaDependente() {
      var self = this;
      self.isLoading = true;
      this.dependenteEditado.birth_date = toTimeStamp(this.dependenteEditado.birth_date);
      ajax("put", "/dependentes/"+ self.dependenteEditado.id, self.dependenteEditado)
        .then(response => {
          self.isLoading = false;
            alerta(
                "success",
                "Atualizado",
                "Carteirinha atualizada com sucesso!"
            );
          let indexItemEditado = self.dependentes.findIndex(
            (x) => x.id == self.dependenteEditado.id
          );
          self.dependentes[indexItemEditado] = self.dependenteEditado;
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    CriaDependente() {
      var self = this;
      self.isLoading = true;
      //this.novoDependente.dependents[0].birth_date = toTimeStamp(this.novoDependente.dependents[0].birth_date);
      this.novoDependente.dependents[0].subscriber_id = this.subscriber.id
      ajax("post", "/assinantes/dependentes/",self.novoDependente)
        .then(response => {
          self.isLoading = false;
            alerta(
              "success",
              "Criado",
              "Dependente criado com sucesso!"
            );
          /* let indexItemEditado = self.dependentes.findIndex(
            (x) => x.id == self.dependenteEditado.id
          );
          self.dependentes[indexItemEditado] = self.dependenteEditado; */
        })
        .catch(error => {
          self.isLoading = false;
          console.log(error)
          tratamento_requisicao(error, this);
        });
    },
    DeletaDependente() {
      var self = this;
      self.isLoading = true;
      ajax("delete", "dependentes/"+self.dependenteDeletado.id)
        .then(response => {
          self.isLoading = false;
            alerta(
              "success",
              "Deletado",
              "Dependente apagado com sucesso!"
            );
        })
        .catch(error => {
          self.isLoading = false;
          tratamento_requisicao(error, this);
        });
    },
    abreModalDetalhesDependente(param) {
      ajax("get", "/operadoras/"+this.subscription.plan.provider_id+"/planos/adm")
      .then(res => {
      this.planos = res.data; 
      })
      .catch(error => {
      console.error('Error fetching plans:', error);
      });
      this.dependenteEditado = Object.assign({}, param);
      this.dependenteEditado.birth_date = toDate(this.dependenteEditado.birth_date);
      this.$bvModal.show('modalDependente')
    },
    abreModalCriaDependente(param) {
      //this.dependenteEditado = Object.assign({}, param);
      //this.dependenteEditado.birth_date = toDate(this.dependenteEditado.birth_date);
      ajax("get", "/operadoras/"+this.subscription.plan.provider_id+"/planos/adm")
      .then(res => {
      this.planos = res.data; 
      })
      .catch(error => {
      console.error('Error fetching plans:', error);
      });
      this.$bvModal.show('modalCriaDependente')
    },
    abreModalDeletaDependente(param) {
      this.dependenteDeletado = Object.assign({}, param);
      this.$bvModal.show('modalDeleta')
    },
    solicitaConfirmacao(){
      if (
        confirm(
          `Deseja notificar os clientes com seus respectivos números de carteirinha?`
        )
      ) {
        var self = this;
        self.isLoading = true;
        ajax(
          "get",
          "/subscribers/" + self.subscriber.id + "/envia_email_com_carteirinhas"
        )
          .then((response) => {
            self.isLoading = false;
            alerta(
              "success",
              "Atualizado",
              "Carteirinha atualizada com sucesso!"
            );
          })
          .catch((error) => {
            self.isLoading = false;
            tratamento_requisicao(error, this);
          });
      }
    },
    verCartao() {
        var self = this;
        self.isLoading = true;
        ajax(
          "post",
          "/descryptografa/" + self.subscription.id
        )
          .then((response) => {
            self.isLoading = false;
            self.card = response;
            if (response.bandeira == null) {
              self.card.bandeira = self.getCardType(self.card.number);
            }
            self.card.expiration = `${self.card.expiration_month}${self.card.expiration_year}`;
            self.verDadosDoCartao = true;
          })
          .catch((error) => {
            console.log(error);
            self.isLoading = false;
            tratamento_requisicao(error, this);
          });
    },
    consultaRecorrencia() {
      let self = this;
      self.isLoading = true;
      
      ajax("get", "https://api.mazeapps.com.br/api/recurrency/7b19c6e3-380d-4c0c-bd31-d562e2c9243d/" + self.subscription.recurrent_payment_uuid)
        .then((response) => {
          self.isLoading = false;
          if (response.RecurrentPayment) {
            self.consulta_recorrencia = response.RecurrentPayment;
            self.consulta_recorrencia.Amount = self.numberWithCommas(self.consulta_recorrencia.Amount); 
            self.StartDate = self.padronizaData(response.RecurrentPayment.StartDate)
            self.NextRecurrency = self.padronizaData(response.RecurrentPayment.NextRecurrency)
            self.RecurrencyStatus = response.RecurrentPayment.Status;
            self.$bvModal.show('modalConsultaRecorrencia');
          }
        })
        .catch((error) => {
          self.isLoading = false;
          alerta("warning", 
            'Não há registro de recorrência para essa assinatura', 
            'Por favor, verifique o recurrent_payment_id no site da Cielo e entre em contato com nossa equipe técnica'
          );
        });
        
    },
    consultaRecorrenciaCPF() {
      let self = this;
      self.isLoading = true;
      
      ajax("get", "https://api.mazeapps.com.br/api/recurrency_cpf/" + self.subscriber.cpf)
        .then((response) => {
          self.isLoading = false;
          
          if (response.data && response.data.response) {
            const validResponses = response.data.response.filter(rp => rp.cielo_data && rp.cielo_data.RecurrentPayment);

            self.lista_recorrencias = validResponses.map(rp => {
              const cielo = rp.cielo_data.RecurrentPayment;

              return {
                ...rp,
                formatted_amount: self.numberWithCommas(cielo.Amount || 0),
                StartDateFormatted: self.padronizaData(cielo.StartDate),
                NextRecurrencyFormatted: self.padronizaData(cielo.NextRecurrency),
                StatusExtenso: self.RecurrencyStatusDefinitions[cielo.Status - 1] || 'Desconhecido',
                RecurrentPaymentId: cielo.RecurrentPaymentId || 'N/A',
                RecurrencyDay: cielo.RecurrencyDay || 'N/A',
                CurrentRecurrencyTry: cielo.CurrentRecurrencyTry,
                SuccessfulRecurrences: cielo.SuccessfulRecurrences,
                transactions: (cielo.RecurrentTransactions || []).map(t => ({
                  ...t,
                  formatted_t_amount: self.numberWithCommas(parseFloat(t.Amount || 0))
                }))
              };
            });

            if (self.lista_recorrencias.length > 0) {
              self.$bvModal.show('modalConsultaRecorrencia');
            } else {
              console.warn("Nenhuma recorrência ativa encontrada na Cielo para este CPF.");
            }
          }
        })
        .catch((error) => {
          self.isLoading = false;
          console.error("Erro ao consultar recorrências por CPF:", error);
        });
    },
    exibirAlertaNaoEncontrado() {
      alerta("warning", 
        'Não há registro de recorrência para essa assinatura', 
        'Por favor, verifique o CPF ou entre em contato com o suporte.'
      );
    },
    visualizarPaymentId(id){
      if(id)
        this.$swal(`Subscription payment id`, id);
      else
      this.$swal(`Não há um ID de pagamento nessa transação`);
    },
    copiaConteudo(target,conteudo){
      this.copyContent(target,conteudo);
    },

    enviarDados() {
      if (this.subscription && this.subscription.id) {
        this.$router.push({ 
          name: 'Copia_Assinatura', 
          params: { 
            id: this.subscription.id 
          } 
        });
      } else {
        this.$swal({
          title: 'Aviso',
          text: 'Nenhuma assinatura válida encontrada.',
          icon: 'warning',
          confirmButtonText: 'OK'
        });
      }
    }
  }
};
</script>